export default function isNot<T>(value: T) {
	return (item: T) => item !== value
}
